(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracCustomerReport', NasracCustomerReport);

    NasracCustomerReport.$inject = ['$resource', 'DateUtils'];

    function NasracCustomerReport ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-customer-reports/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { 
            	
            	url : 'api/nasrac-customer-reports/siteIds',
            	method: 'GET', 
            	isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },'download_report' : {
				method : 'GET',
				url : 'api/nasrac-customer-reports/download/:reportName/:siteId/:isArchived',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},'query_files_by_siteId': { 
            	
            	url : 'api/nasrac-customer-reports/siteIds/:siteId/:isArchived',
            	method: 'GET', 
            	isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
